import * as THREE from 'three';

/** Lite PlanSceneBuilder.skyGradientImage: cool sky, warm ground, two window lobes. */
export function makeInteriorEnvironment(renderer: THREE.WebGLRenderer): THREE.WebGLRenderTarget {
  const canvas = document.createElement('canvas'); canvas.width = 1024; canvas.height = 512;
  const ctx = canvas.getContext('2d')!;
  const gradient = ctx.createLinearGradient(0, 0, 0, 512);
  gradient.addColorStop(0, '#bac9de'); gradient.addColorStop(.45, '#99a3b0');
  gradient.addColorStop(.55, '#6e6e6b'); gradient.addColorStop(1, '#3d3833');
  ctx.fillStyle = gradient; ctx.fillRect(0, 0, 1024, 512);
  for (const [x, alpha] of [[.18, 1], [.68, .45]]) {
    ctx.save(); ctx.translate(x * 1024, .52 * 512); ctx.scale(3.7, 1);
    const windowLight = ctx.createRadialGradient(0, 0, 0, 0, 0, .035 * 512);
    windowLight.addColorStop(0, `rgba(255,255,255,${alpha})`); windowLight.addColorStop(1, 'rgba(255,255,255,0)');
    ctx.fillStyle = windowLight; ctx.fillRect(-40, -40, 80, 80); ctx.restore();
  }
  const texture = new THREE.CanvasTexture(canvas); texture.colorSpace = THREE.SRGBColorSpace;
  texture.mapping = THREE.EquirectangularReflectionMapping;
  const generator = new THREE.PMREMGenerator(renderer);
  const result = generator.fromEquirectangular(texture);
  texture.dispose(); generator.dispose();
  return result;
}
